import { NgModule } from "@angular/core";
import { RouterModule, Route } from "@angular/router";
import { ImageCropperModule } from "ng2-img-cropper";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatSnackBarConfig } from "@angular/material";
import { TagInputModule } from "ngx-chips";
import { Ng2FileInputModule } from "ng2-file-input";

import { MaterialAppModule } from "../ngmaterial.module";

import { SamlWizardModule } from "./users/saml-wizard/saml-wizard.module";
import { UserWizardModule } from "./users/user-wizard/user-wizard.module";
import { ApplicationsComponent } from "./applications/applications.component";
import { ApplicationsService } from "./applications/applications.service";
import { ClientDownloadComponent } from "./client-download/client-download.component";
import { PoliciesComponent } from "./policies/policies.component";
import { HomeComponent } from "./home/home.component";
import { SummaryComponent } from "./summary/summary.component";
import { TaggerService } from "./tagger/tagger.service";
import { UsersComponent } from "./users/users.component";
import { WizardNavigationComponent } from "./wizard-navigation";
import { WizardNavigationTopComponent } from "./wizard-navigation-top/wizard-navigation-top.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import {
	ApplicationWizardService,
	ApplicationSelectTypeComponent,
	ApplicationWebUrlComponent,
	ApplicationWizardSummaryComponent,
	ApplicationImageSelectComponent,
	ApplicationNetworkServiceComponent,
	ApplicationPortsComponent
} from "./applications/application-wizard";
import { AdminGuard, AuthenticateGuard } from "../common/guards";
import { CommonModule } from "../common/common.module";
import { UserWizardService } from "./users/user-wizard/user-wizard.service";
import { SamlWizardService } from "./users/saml-wizard/saml-wizard.service";

import {
	UserWizardEditComponent
} from "./users/user-wizard";
import {
	SamlUploadComponent,
	SamlDownloadComponent,
	SamlAttributesComponent,
	SamlSummaryComponent,
	SamlSelectIdpComponent
} from "./users/saml-wizard";
import { PolicyWizardModule } from "./policies/policy-wizard/policy-wizard.module";
import { PolicyWizardService } from "./policies/policy-wizard";
import { WizardDialogComponent } from "./wizard-dialog/wizard-dialog.component";
import { WizardDialogService } from "./wizard-dialog/wizard-dialog.service";
import { WizardPageComponent } from "./wizard-page/wizard-page.component";
import { GenericTableModule } from "../genericTable";
import { ApplicationImageComponent } from "../common/application-image/application-image.component";
import { GatewaysModule } from "./gateways/gateways.module";
import { CustomUserEmailComponent } from "./users/customUserEmail/custom-user-email.component";
import { SamlAliasesComponent, SamlAliasesService } from "./saml-aliases";
import { SamlAliasEditComponent } from "./saml-aliases/saml-alias-wizard/saml-alias-edit/saml-alias-edit.component";

export const ROUTES: Route[] = [
	{
		path: "wizard",
		component: WizardPageComponent,
		canActivate: [
			AuthenticateGuard,
			AdminGuard
		],
		children: [
			{
				path: "applications",
				component: ApplicationsComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				],
				data: { previous: "/home", next: "/users" }
			},
			{
				path: "users",
				component: UsersComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				],
				data: { previous: "/applications", next: "/policies" }
			},
			{
				path: "policies",
				component: PoliciesComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				],
				data: { previous: "/users", next: "/summary" }
			},
			{
				path: "home",
				component: HomeComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				],
				data: { previous: "", next: "/applications" }
			},
			{
				path: "summary",
				component: SummaryComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				],
				data: { previous: "policies", next: "/access" }
			},
			{
				path: "access",
				component: ClientDownloadComponent,
				canActivate: [
					AuthenticateGuard,
					AdminGuard
				],
				data: { previous: "/summary", next: "/administration" }
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(ROUTES),
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		BrowserModule,
		ImageCropperModule,
		TagInputModule,
		SamlWizardModule,
		UserWizardModule,
		PolicyWizardModule,
		MaterialAppModule,
		Ng2FileInputModule.forRoot(),
		GenericTableModule,
		GatewaysModule
	],
	declarations: [
		ApplicationsComponent,
		ClientDownloadComponent,
		PoliciesComponent,
		HomeComponent,
		SummaryComponent,
		UsersComponent,
		WizardNavigationComponent,
		WizardNavigationTopComponent,
		ConfirmationDialogComponent,
		ApplicationSelectTypeComponent,
		ApplicationWizardSummaryComponent,
		ApplicationWebUrlComponent,
		ApplicationImageSelectComponent,
		ApplicationNetworkServiceComponent,
		ApplicationPortsComponent,
		WizardDialogComponent,
		WizardPageComponent,
		CustomUserEmailComponent,
		SamlAliasesComponent,
		SamlAliasEditComponent
	],
	entryComponents: [
		ConfirmationDialogComponent,
		WizardDialogComponent,
		UserWizardEditComponent,
		ApplicationSelectTypeComponent,
		ApplicationWizardSummaryComponent,
		ApplicationWebUrlComponent,
		ApplicationImageSelectComponent,
		ApplicationNetworkServiceComponent,
		ApplicationPortsComponent,
		SamlUploadComponent,
		SamlDownloadComponent,
		SamlSelectIdpComponent,
		SamlSummaryComponent,
		SamlAttributesComponent,
		ApplicationImageComponent,
		CustomUserEmailComponent,
		SamlAliasEditComponent
	],
	providers: [
		ApplicationsService,
		SamlAliasesService,
		TaggerService,
		MatSnackBarConfig,
		ApplicationWizardService,
		UserWizardService,
		SamlWizardService,
		WizardDialogService,
		PolicyWizardService
	],
	exports: [
		ApplicationsComponent,
		HomeComponent,
		SummaryComponent,
		UsersComponent,
		WizardNavigationComponent,
		WizardNavigationTopComponent,
		WizardPageComponent,
		FormsModule,
		GatewaysModule,
		SamlAliasEditComponent
	]
})
export class AdministrativeModule { }
